export default __webpack_public_path__ + "static/media/140-east-timor.df402b98.svg";